<template>
  <div>
    <b-row>
      <!-- 基础信息 -->
      <b-col cols="4">
        <b-card>
          <b-card-title class="text-truncate"> 基础信息</b-card-title>
          <b-card-text>
            <b-row>
              <b-col class="d-flex align-items-center mt-1" cols="4">
                <b-avatar class="mr-1" rounded variant="light-info">
                  <b-icon-thermometer-sun font-scale="1.5"/>
                </b-avatar>
                <div style="min-width: 0">
                  <div class="text-truncate">供热区域</div>
                  <div class="text-truncate">
                    <!--                      <span class="text-info">郭化路1号站</span>-->
                    <span class="text-info">{{ projectBaseInfo['region'] || '---' }}</span>
                  </div>
                </div>
              </b-col>
              <b-col class="d-flex align-items-center" cols="6">
                <b-avatar class="mr-1" rounded variant="light-danger">
                  <b-icon-pin-map-fill font-scale="1.5"/>
                </b-avatar>
                <div style="min-width: 0">
                  <div class="text-truncate">所在位置</div>
                  <div class="text-truncate text-danger">
                    <!--                    青岛市市北区江源路一号-->
                    {{ projectBaseInfo['position'] || '---' }}
                  </div>
                </div>
              </b-col>


              <b-col class="d-flex align-items-center mt-1" cols="4">
                <b-avatar class="mr-1" rounded variant="light-info">
                  <b-icon-calendar-date-fill font-scale="1.5"/>
                </b-avatar>
                <div style="min-width: 0">
                  <div class="text-truncate">启用日期</div>
                  <div class="text-truncate text-info">
                    {{ projectBaseInfo['stdate'] || '---' }}
                  </div>
                </div>
              </b-col>

              <b-col class="d-flex align-items-center mt-1" cols="4">
                <b-avatar class="mr-1" rounded variant="light-primary">
                  <b-icon-share-fill font-scale="1.5"/>
                </b-avatar>
                <div style="min-width: 0">
                  <div class="text-truncate">入网面积</div>
                  <div class="text-truncate">
                    <span class="text-primary">{{ projectBaseInfo['measure'] || '---' }}</span>
                    <small>&nbsp;m<sup>2</sup></small>
                  </div>
                </div>
              </b-col>

              <b-col class="d-flex align-items-center mt-1" cols="4">
                <b-avatar class="mr-1" rounded variant="light-success">
                  <b-icon-building font-scale="1.5"/>
                </b-avatar>
                <div style="min-width: 0">
                  <div class="text-truncate">建筑类别</div>
                  <div class="text-truncate">
                    <span class="text-success">{{ projectBaseInfo['type'] || '---' }}</span>
                  </div>
                </div>
              </b-col>

            </b-row>
          </b-card-text>
        </b-card>

        <b-card>
          <b-card-title class="text-truncate"> {{ projectBaseInfo['cost_d_title'] || '---' }}</b-card-title>
          <b-card-text>
            <b-row>
              <b-col cols="4">
                <b-alert show variant="danger" class="mb-0">
                  <div class="alert-body text-center py-50">
                    <b-icon-thermometer-half font-scale="1.5" class="my-50"/>
                    <p class="mb-50">热</p>
                    <div
                        class="text-danger font-digit text-truncate"
                        style="font-size: 2rem"
                    >
                      {{ projectBaseInfo['cost_d_heat'] || '---' }}
                    </div>
                    <div class="mb-25">
                      <label>GJ/万m<sup>2</sup>d</label>
                    </div>
                    <b-badge variant="light-danger" style="font-weight: normal">
                      <div class="mb-25">排名</div>
                      <span style="font-size: 1.1rem">{{ projectBaseInfo['cost_d_heat_rank'] || '---' }}</span>
                    </b-badge>
                  </div>
                </b-alert>
              </b-col>

              <b-col cols="4">
                <b-alert show variant="success" class="mb-0">
                  <div class="alert-body text-center py-50">
                    <b-icon-droplet-fill class="my-50" font-scale="1.5"/>
                    <p class="mb-50">水</p>
                    <div
                        class="text-success font-digit text-truncate"
                        style="font-size: 2rem"
                    >
                      <span>{{ projectBaseInfo['cost_d_water'] || '---' }}</span>
                    </div>
                    <div class="mb-25">
                      <label>m<sup>3</sup>/万m<sup>2</sup>d</label>
                    </div>
                    <b-badge
                        variant="light-success"
                        style="font-weight: normal"
                    >
                      <div class="mb-25">排名</div>
                      <span style="font-size: 1.1rem">{{ projectBaseInfo['cost_d_water_rank'] || '---' }}</span>
                    </b-badge>
                  </div>
                </b-alert>
              </b-col>

              <b-col cols="4">
                <b-alert show variant="warning" class="mb-0">
                  <div class="alert-body text-center py-50">
                    <b-icon-lightning-fill class="my-50" font-scale="1.5"/>
                    <p class="mb-50">电</p>
                    <div
                        class="text-warning font-digit text-truncate"
                        style="font-size: 2rem"
                        id="tooltip-target-3"
                    >
                      <span>{{ projectBaseInfo['cost_d_elec'] || '---' }}</span>
                    </div>
                    <div class="mb-25">
                      <label>kWh/万m<sup>2</sup>d</label>
                    </div>
                    <b-badge
                        variant="light-warning"
                        style="font-weight: normal"
                    >
                      <div class="mb-25">排名</div>
                      <span style="font-size: 1.1rem">{{ projectBaseInfo['cost_d_elec_rank'] || '---' }}</span>
                    </b-badge>
                  </div>
                </b-alert>
              </b-col>

              <!--              <b-col cols="12">-->
              <!--                <div id="container_3" style="height: 12rem" class="mt-1"></div>-->
              <!--              </b-col>-->
            </b-row>
          </b-card-text>
        </b-card>

        <b-card>
          <b-card-title class="text-truncate"> {{ projectBaseInfo['cost_y_title'] || '---' }}</b-card-title>
          <b-card-text>
            <b-row>
              <b-col cols="4">
                <b-alert show variant="danger" class="mb-0">
                  <div class="alert-body text-center py-50">
                    <b-icon-thermometer-half font-scale="1.5" class="my-50"/>
                    <p class="mb-50">热</p>
                    <div
                        class="text-danger font-digit text-truncate"
                        style="font-size: 2rem"
                    >
                      {{ projectBaseInfo['cost_y_heat'] || '---' }}
                    </div>
                    <div class="mb-25">
                      <label>GJ/万m<sup>2</sup>d</label>
                    </div>
                    <b-badge variant="light-danger" style="font-weight: normal">
                      <div class="mb-25">排名</div>
                      <span style="font-size: 1.1rem">{{ projectBaseInfo['cost_y_heat_rank'] || '---' }}</span>
                    </b-badge>
                  </div>
                </b-alert>
              </b-col>

              <b-col cols="4">
                <b-alert show variant="success" class="mb-0">
                  <div class="alert-body text-center py-50">
                    <b-icon-droplet-fill class="my-50" font-scale="1.5"/>
                    <p class="mb-50">水</p>
                    <div
                        class="text-success font-digit text-truncate"
                        style="font-size: 2rem"
                    >
                      {{ projectBaseInfo['cost_y_water'] || '---' }}
                    </div>
                    <div class="mb-25">
                      <label>m<sup>3</sup>/万m<sup>2</sup>d</label>
                    </div>
                    <b-badge
                        variant="light-success"
                        style="font-weight: normal"
                    >
                      <div class="mb-25">排名</div>
                      <span style="font-size: 1.1rem">{{ projectBaseInfo['cost_y_water_rank'] || '---' }}</span>
                    </b-badge>
                  </div>
                </b-alert>
              </b-col>

              <b-col cols="4">
                <b-alert show variant="warning" class="mb-0">
                  <div class="alert-body text-center py-50">
                    <b-icon-lightning-fill class="my-50" font-scale="1.5"/>
                    <p class="mb-50">电</p>
                    <div
                        class="text-warning font-digit text-truncate"
                        style="font-size: 2rem"
                        id="tooltip-target-3"
                    >
                      {{ projectBaseInfo['cost_y_elec'] || '---' }}
                    </div>
                    <div class="mb-25">
                      <label>kWh/万m<sup>2</sup>d</label>
                    </div>
                    <b-badge
                        variant="light-warning"
                        style="font-weight: normal"
                    >
                      <div class="mb-25">排名</div>
                      <span style="font-size: 1.1rem">{{ projectBaseInfo['cost_y_elec_rank'] || '---' }}</span>
                    </b-badge>
                  </div>
                </b-alert>
              </b-col>

              <!--              <b-col cols="12">-->
              <!--                <div id="container_3" style="height: 12rem" class="mt-1"></div>-->
              <!--              </b-col>-->
            </b-row>
          </b-card-text>
        </b-card>

        <b-card>
          <b-card-title class="text-truncate"> 节能</b-card-title>
          <b-card-text style="height: 5rem">
            <b-row>
              <b-col cols="12">
                <b-alert show variant="info" class="mb-0">
                  <div class="alert-body text-center py-1 d-flex" style="height: 5rem;margin-left: 6%">
                    <b-icon-lightning-fill font-scale="2" class="mt-50 mr-50"/>
                    <p class="mt-50 mr-1">综合节能率</p>
                    <div
                        class="text-info font-digit text-truncate"
                        style="font-size: 2.5rem;line-height: 2.5rem"
                    >
                      {{ projectBaseInfo['energy_saving_percent'] || '---' }}
                    </div>
                    <div class="mb-25 mt-1 mx-50">
                      <label style="font-size: 1.5rem">%</label>
                    </div>

                    <b-icon-lightbulb-fill font-scale="2" class="mt-50 mr-50 ml-4"/>
                    <p class="mt-50 mr-1">累计节能量</p>
                    <div
                        class="text-info font-digit text-truncate"
                        style="font-size: 2.5rem;line-height: 2.5rem"
                    >
                      {{ projectBaseInfo['energy_saving_total'] || '---' }}
                    </div>
                    <div class="mb-25 mt-1 mx-50">
                      <label style="font-size: 1.5rem">GJ</label>
                    </div>
                  </div>
                </b-alert>
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>

        <b-card>
          <b-card-title class="text-truncate"> AI大模型</b-card-title>
          <b-card-text style="height: 3.2rem">
            <b-row>
              <b-col cols="12" class="cursor-pointer text-center" @click="to_diagnosis">

                <b-icon-stars scale="2.6" class="mr-75 text-primary" />
                <span class="text-primary" style="line-height: 2rem;font-weight: 600;font-size: 1.2rem">建研查微</span>

                <b-img
                    src="/images/deepseek-logo.png"
                    class="ml-2"
                     style="height: 2rem;"></b-img>
<!--                <b-img src="/images/wenxinyiyan-logo.png" class="ml-2" style="height: 2rem;" ></b-img>-->




<!--                <b-button class="active d-flex" variant="primary" to="/83/cabr/diagnosis/agent-list" style="background: rgba(255,255,255,0.3) !important;">-->

<!--                                    <div class="mr-50" style="height: 2rem;width: 2rem">-->
<!--                                      <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path id="path" d="M27.501 8.46875C27.249 8.3457 27.1406 8.58008 26.9932 8.69922C26.9434 8.73828 26.9004 8.78906 26.8584 8.83398C26.4902 9.22852 26.0605 9.48633 25.5 9.45508C24.6787 9.41016 23.9785 9.66797 23.3594 10.2969C23.2275 9.52148 22.79 9.05859 22.125 8.76172C21.7764 8.60742 21.4238 8.45312 21.1807 8.11719C21.0098 7.87891 20.9639 7.61328 20.8779 7.35156C20.8242 7.19336 20.7695 7.03125 20.5879 7.00391C20.3906 6.97266 20.3135 7.13867 20.2363 7.27734C19.9258 7.84375 19.8066 8.46875 19.8174 9.10156C19.8447 10.5234 20.4453 11.6562 21.6367 12.4629C21.7725 12.5547 21.8076 12.6484 21.7646 12.7832C21.6836 13.0605 21.5869 13.3301 21.501 13.6074C21.4473 13.7852 21.3662 13.8242 21.1768 13.7461C20.5225 13.4727 19.957 13.0684 19.458 12.5781C18.6104 11.7578 17.8438 10.8516 16.8877 10.1426C16.6631 9.97656 16.4395 9.82227 16.207 9.67578C15.2314 8.72656 16.335 7.94727 16.5898 7.85547C16.8574 7.75977 16.6826 7.42773 15.8193 7.43164C14.957 7.43555 14.167 7.72461 13.1611 8.10938C13.0137 8.16797 12.8594 8.21094 12.7002 8.24414C11.7871 8.07227 10.8389 8.0332 9.84766 8.14453C7.98242 8.35352 6.49219 9.23633 5.39648 10.7441C4.08105 12.5547 3.77148 14.6133 4.15039 16.7617C4.54883 19.0234 5.70215 20.8984 7.47559 22.3633C9.31348 23.8809 11.4307 24.625 13.8457 24.4824C15.3125 24.3984 16.9463 24.2012 18.7881 22.6406C19.2529 22.8711 19.7402 22.9629 20.5498 23.0332C21.1729 23.0918 21.7725 23.002 22.2373 22.9062C22.9648 22.752 22.9141 22.0781 22.6514 21.9531C20.5186 20.959 20.9863 21.3633 20.5605 21.0371C21.6445 19.752 23.2783 18.418 23.917 14.0977C23.9668 13.7539 23.9238 13.5391 23.917 13.2598C23.9131 13.0918 23.9512 13.0254 24.1445 13.0059C24.6787 12.9453 25.1973 12.7988 25.6738 12.5352C27.0557 11.7793 27.6123 10.5391 27.7441 9.05078C27.7637 8.82422 27.7402 8.58789 27.501 8.46875ZM15.46 21.8613C13.3926 20.2344 12.3906 19.6992 11.9766 19.7227C11.5898 19.7441 11.6592 20.1875 11.7441 20.4766C11.833 20.7617 11.9492 20.959 12.1123 21.209C12.2246 21.375 12.3018 21.623 12 21.8066C11.334 22.2207 10.1768 21.668 10.1221 21.6406C8.77539 20.8477 7.64941 19.7988 6.85547 18.3652C6.08984 16.9844 5.64453 15.5039 5.57129 13.9238C5.55176 13.541 5.66406 13.4062 6.04297 13.3379C6.54199 13.2461 7.05762 13.2266 7.55664 13.2988C9.66602 13.6074 11.4619 14.5527 12.9668 16.0469C13.8262 16.9004 14.4766 17.918 15.1465 18.9121C15.8584 19.9688 16.625 20.9746 17.6006 21.7988C17.9443 22.0879 18.2197 22.3086 18.4824 22.4707C17.6895 22.5586 16.3652 22.5781 15.46 21.8613ZM16.4502 15.4805C16.4502 15.3105 16.5859 15.1758 16.7568 15.1758C16.7949 15.1758 16.8301 15.1836 16.8613 15.1953C16.9033 15.2109 16.9424 15.2344 16.9727 15.2695C17.0273 15.3223 17.0586 15.4004 17.0586 15.4805C17.0586 15.6504 16.9229 15.7852 16.7529 15.7852C16.582 15.7852 16.4502 15.6504 16.4502 15.4805ZM19.5273 17.0625C19.3301 17.1426 19.1328 17.2129 18.9434 17.2207C18.6494 17.2344 18.3281 17.1152 18.1533 16.9688C17.8828 16.7422 17.6895 16.6152 17.6074 16.2168C17.5732 16.0469 17.5928 15.7852 17.623 15.6348C17.6934 15.3105 17.6152 15.1035 17.3877 14.9141C17.2012 14.7598 16.9658 14.7188 16.7061 14.7188C16.6094 14.7188 16.5205 14.6758 16.4541 14.6406C16.3457 14.5859 16.2568 14.4512 16.3418 14.2852C16.3691 14.2324 16.501 14.1016 16.5322 14.0781C16.8838 13.877 17.29 13.9434 17.666 14.0938C18.0146 14.2363 18.2773 14.498 18.6562 14.8672C19.0439 15.3145 19.1133 15.4395 19.334 15.7734C19.5078 16.0371 19.667 16.3066 19.7754 16.6152C19.8408 16.8066 19.7559 16.9648 19.5273 17.0625Z" fill-rule="nonzero" fill="#4D6BFE"></path></svg>-->
<!--                                    </div>-->
<!--                                    <span style="line-height: 2rem">DeepSeek</span>-->
<!--                </b-button>-->
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>

      </b-col>

      <!-- 建筑图片 -->
      <b-col
          cols="8"
          style="pointer-events: none; display: flex; flex-direction: column"
      >
        <b-card>
          <b-card-text class="position-relative" style="height: 505px;">
            <h1
                class="font-title text-center mt-0 mb-0"
                style="font-size: 2rem; pointer-events: auto"
            >
              {{ projectBaseInfo['region'] || '---' }}
            </h1>

            <div style="
            position: absolute;
            top: 0;
            width: 100%;
            height: 520px;
            z-index: 0;
            background-image: url(/images/heating_plant.png);
            background-position: center bottom;
            background-size: contain;
            background-repeat: no-repeat;
          "></div>

            <div
                class="position-absolute text-primary"
                style="top: 5rem; right: 2rem"
            >
              <span>室外温度</span>
              <div>
                <span
                    v-if="
                    realTimeParams['_40001'] &&
                    realTimeParams['_40001']['EnvDataH']
                  "
                >
                  {{
                    Math.round(realTimeParams["_40001"]["EnvDataH"] * 100) /
                    100
                  }}
                </span>
                <span v-else>0.00</span>
                <span class="ml-25">℃</span>
              </div>
            </div>

            <div
                class="position-absolute text-primary"
                style="top: 5.5rem; left: 9rem"
            >
              <!--              <span>一次供压</span>-->
              <div>
                <span
                    v-if="
                    realTimeParams['_40011'] &&
                    realTimeParams['_40011']['EnvDataH']
                  "
                >
                  {{ realTimeParams["_40011"]["EnvDataH"] }}
                </span>
                <span v-else>0.00</span>
                <span class="ml-25">kPa</span>
              </div>
            </div>
            <div
                class="position-absolute text-primary"
                style="top: 5.5rem; left: 16rem"
            >
              <!--              <span>一次供温</span>-->
              <div>
                <span
                    v-if="
                    realTimeParams['_40003'] &&
                    realTimeParams['_40003']['EnvDataH']
                  "
                >
                  {{ realTimeParams["_40003"]["EnvDataH"] }}
                </span>
                <span v-else>0.00</span>
                <span class="ml-25">℃</span>
              </div>
            </div>

            <div
                class="position-absolute text-primary"
                style="top: 5.5rem; left: 21.5rem"
            >
              <!--              <span>调节阀1开度</span>-->
              <div>
                <span
                    v-if="
                    realTimeParams['_40081'] &&
                    realTimeParams['_40081']['EnvDataH']
                  "
                >
                  {{ realTimeParams["_40081"]["EnvDataH"] }}
                </span>
                <span v-else>0.00</span>
                <span class="ml-25">%</span>
              </div>
            </div>

            <div
                class="position-absolute text-primary"
                style="top: 4rem; left: 50rem"
            >
              <!--              <span>二次供热瞬时流量</span>-->
              <div>
                <span
                    v-if="
                    realTimeParams['_40716'] &&
                    realTimeParams['_40716']['EnvDataH']
                  "
                >
                  {{ realTimeParams["_40716"]["EnvDataH"] }}
                </span>
                <span v-else>0.00</span>
                <span class="ml-25">m<sup>3</sup>/h</span>
              </div>
            </div>

            <div
                class="position-absolute text-primary"
                style="top: 5.5rem; left: 50rem"
            >
              <!--              <span>二次供热瞬时热量</span>-->
              <div>
                <span
                    v-if="
                    realTimeParams['_40712'] &&
                    realTimeParams['_40712']['EnvDataH']
                  "
                >
                  {{ realTimeParams["_40712"]["EnvDataH"] }}
                </span>
                <span v-else>0.00</span>
                <span class="ml-25">%</span>
              </div>
            </div>

            <div
                class="position-absolute text-primary"
                style="top: 5.5rem; left: 58rem"
            >
              <!--              <span>二次供压</span>-->
              <div>
                <span
                    v-if="
                    realTimeParams['_40015'] &&
                    realTimeParams['_40015']['EnvDataH']
                  "
                >
                  {{ realTimeParams["_40015"]["EnvDataH"] }}
                </span>
                <span v-else>0.00</span>

                <span class="ml-25">kPa</span>
              </div>
            </div>

            <div
                class="position-absolute text-primary"
                style="top: 5.5rem; left: 65rem"
            >
              <!--              <span>二次供温</span>-->
              <div>
                <span
                    v-if="
                    realTimeParams['_40007'] &&
                    realTimeParams['_40007']['EnvDataH']
                  "
                >
                  {{ realTimeParams["_40007"]["EnvDataH"] }}
                </span>
                <span v-else>0.00</span>

                <span class="ml-25">℃</span>
              </div>
            </div>


            <div
                class="position-absolute text-info"
                style="top: 22rem; left: 10rem"
            >
              <!--              <span>一次回压</span>-->
              <div>
                <span
                    v-if="
                    realTimeParams['_40013'] &&
                    realTimeParams['_40013']['EnvDataH']
                  "
                >
                  {{ realTimeParams["_40013"]["EnvDataH"] }}
                </span>
                <span v-else>0.00</span>
                <span class="ml-25">kPa</span>
              </div>
            </div>

            <div
                class="position-absolute text-info"
                style="top: 22rem; left: 18rem"
            >
              <!--              <span>一次回温</span>-->
              <div>
                <span
                    v-if="
                    realTimeParams['_40005'] &&
                    realTimeParams['_40005']['EnvDataH']
                  "
                >
                  {{ realTimeParams["_40005"]["EnvDataH"] }}
                </span>
                <span v-else>0.00</span>
                <span class="ml-25">℃</span>
              </div>
            </div>

            <div
                class="position-absolute text-info"
                style="top: 22rem; left: 25rem"
            >
              <!--              <span>一次供瞬时流量</span>-->
              <div>
                <span
                    v-if="
                    realTimeParams['_40021'] &&
                    realTimeParams['_40021']['EnvDataH']
                  "
                >
                  {{ realTimeParams["_40021"]["EnvDataH"] }}
                </span>
                <span v-else>0.00</span>
                <span class="ml-25">m<sup>3</sup>/h</span>
              </div>
            </div>

            <div
                class="position-absolute text-info"
                style="top: 24rem; left: 25rem"
            >
              <!--              <span>一次供瞬时热量</span>-->
              <div>
                <span
                    v-if="
                    realTimeParams['_40019'] &&
                    realTimeParams['_40019']['EnvDataH']
                  "
                >
                  {{ realTimeParams["_40019"]["EnvDataH"] }}
                </span>
                <span v-else>0.00</span>
                <span class="ml-25">GJ</span>
              </div>
            </div>

            <div
                class="position-absolute text-success"
                style="top: 12rem; left: 48rem"
            >
              <!--              <span>1#循环泵频率</span>-->
              <div>
                <span
                    v-if="
                    realTimeParams['_40087'] &&
                    realTimeParams['_40087']['EnvDataH']
                  "
                >
                  {{ realTimeParams["_40087"]["EnvDataH"] }}
                </span>
                <span v-else>0.00</span>
                <span class="ml-25">Hz</span>
              </div>
            </div>

            <div
                class="position-absolute text-success"
                style="top: 12rem; left: 58rem"
            >
              <!--              <span>二次回压</span>-->
              <div>
                <span
                    v-if="
                    realTimeParams['_40017'] &&
                    realTimeParams['_40017']['EnvDataH']
                  "
                >
                  {{ realTimeParams["_40017"]["EnvDataH"] }}
                </span>
                <span v-else>0.00</span>
                <span class="ml-25">kPa</span>
              </div>
            </div>

            <div
                class="position-absolute text-success"
                style="top: 12rem; left: 65rem"
            >
              <!--              <span>二次回温</span>-->
              <div>
                <span
                    v-if="
                    realTimeParams['_40009'] &&
                    realTimeParams['_40009']['EnvDataH']
                  "
                >
                  {{ realTimeParams["_40009"]["EnvDataH"] }}
                </span>
                <span v-else>0.00</span>
                <span class="ml-25">℃</span>
              </div>
            </div>

            <div
                class="position-absolute text-success"
                style="top: 25rem; left: 47rem"
            >
              <!--              <span>2#循环泵频率</span>-->
              <div>
                <span
                    v-if="
                    realTimeParams['_40095'] &&
                    realTimeParams['_40095']['EnvDataH']
                  "
                >
                  {{ realTimeParams["_40095"]["EnvDataH"] }}
                </span>
                <span v-else>0.00</span>
                <span class="ml-25">Hz</span>
              </div>
            </div>

            <div
                class="position-absolute text-success"
                style="top: 18rem; left: 59rem"
            >
              <!--              <span>1#补水泵频率</span>-->
              <div>
                <span
                    v-if="
                    realTimeParams['_40103'] &&
                    realTimeParams['_40103']['EnvDataH']
                  "
                >
                  {{ realTimeParams["_40103"]["EnvDataH"] }}
                </span>
                <span v-else>0.00</span>
                <span class="ml-25">Hz</span>
              </div>
            </div>

            <div
                class="position-absolute text-success"
                style="top: 27.5rem; left: 60rem"
            >
              <!--              <span>1#补水泵频率</span>-->
              <div>
                <span
                    v-if="
                    realTimeParams['_40103'] &&
                    realTimeParams['_40103']['EnvDataH']
                  "
                >
                  {{ realTimeParams["_40103"]["EnvDataH"] }}
                </span>
                <span v-else>0.00</span>
                <span class="ml-25">Hz</span>
              </div>
            </div>

          </b-card-text>
        </b-card>

        <b-card>
          <b-card-title class="text-truncate"> 逐时供热</b-card-title>
          <b-card-text>
            <div id="container_1" style="height: 12rem"></div>
            <div class="position-absolute" style="bottom: 3.2rem; left: 5rem">
              今日预计最大负荷
              <b-badge variant="light-danger" class="ml-10">{{
                  heatPredictionMax['hour'].value || "0"
                }}
              </b-badge>
              <small> kW @ {{ heatPredictionMax['day'].time || "---" }}</small>
            </div>
          </b-card-text>
        </b-card>

        <b-card>
          <b-card-title class="text-truncate"> 逐日供热</b-card-title>
          <b-card-text>
            <div id="container_2" style="height: 12rem"></div>
            <div class="position-absolute" style="bottom: 3.2rem; left: 5rem">
              本月预计最大负荷
              <b-badge variant="light-danger" class="ml-10">{{
                  heatPredictionMax['day'].value || "0"
                }}
              </b-badge>
              <small> kW @ {{ heatPredictionMax['day'].time || "---" }}</small>
            </div>
          </b-card-text>
        </b-card>
      </b-col>

      <b-col cols="3" style="display: none">
        <!-- 气象信息 -->
        <b-card>
          <b-card-title class="text-truncate"> 气象信息</b-card-title>
          <b-card-text>
            <b-row>
              <b-col class="text-center" cols="3">
                <p class="mb-1">最高温度</p>
                <div
                    class="text-danger font-digit text-truncate"
                    style="font-size: 2rem"
                >
                  {{ projectBaseInfo['temp_max'] || '---' }}
                </div>
                <label>℃</label>
              </b-col>

              <b-col class="text-center" cols="3">
                <p class="mb-1">最低温度</p>
                <div
                    class="text-primary font-digit text-truncate"
                    style="font-size: 2rem"
                >
                  {{ projectBaseInfo['temp_min'] || '---' }}
                </div>
                <label>℃</label>
              </b-col>

              <b-col class="text-center" cols="3">
                <p class="mb-1">阴晴雨雪</p>
                <div
                    class="text-info font-digit text-truncate"
                    style="font-size: 2rem"
                >
                  {{ projectBaseInfo['weather'] || '---' }}
                </div>
              </b-col>

              <b-col class="text-center" cols="3">
                <p class="mb-1">室外温度</p>
                <div
                    class="text-warning font-digit text-truncate"
                    style="font-size: 2rem"
                >
                  <span
                      v-if="
                      realTimeParams['_40001'] &&
                      realTimeParams['_40001']['EnvDataH']
                    "
                  >
                    {{
                      Math.round(realTimeParams["_40001"]["EnvDataH"] * 100) /
                      100
                    }}
                  </span>
                  <span v-else>0.00</span>
                </div>
                <label>℃</label>
              </b-col>
            </b-row>
          </b-card-text>
        </b-card>

        <b-card>
          <b-card-title class="text-truncate"> 节能诊断</b-card-title>

          <b-card-text>
            <vue-perfect-scrollbar style="height: 23.7rem">
              <app-timeline v-if="alarmData['energy_saving']">
                <app-timeline-item
                    v-for="(item, index) in alarmData['energy_saving']"
                    :key="index"
                    :time="item['create_date']"
                    :title="item['fault_name']"
                    :variant="
                    item['degree'] === '提醒'
                      ? 'info'
                      : item['degree'] === '一般'
                      ? 'warning'
                      : 'danger'
                  "
                    class="pb-1"
                >
                </app-timeline-item>
              </app-timeline>
              <p v-else class="text-center" style="margin-top: 20%">
                暂无诊断数据
              </p>
            </vue-perfect-scrollbar>
          </b-card-text>
        </b-card>

        <b-card>
          <b-card-title class="text-truncate"> 告警</b-card-title>
          <b-tabs fill>
            <b-tab title="安全告警" active>
              <b-card-text>
                <vue-perfect-scrollbar style="height: 21.8rem">
                  <app-timeline v-if="alarmData['security']">
                    <app-timeline-item
                        v-for="(item, index) in alarmData['security']"
                        :key="index"
                        :time="item['create_date']"
                        :title="item['fault_name']"
                        :variant="
                        item['degree'] === '提醒'
                          ? 'info'
                          : item['degree'] === '一般'
                          ? 'warning'
                          : 'danger'
                      "
                        class="pb-1"
                    >
                    </app-timeline-item>
                  </app-timeline>
                  <p v-else class="text-center" style="margin-top: 20%">
                    暂无安全告警数据
                  </p>
                </vue-perfect-scrollbar>
              </b-card-text>
            </b-tab>
            <b-tab title="功能告警">
              <b-card-text>
                <vue-perfect-scrollbar style="height: 21.8rem">
                  <app-timeline v-if="alarmData['functiom']">
                    <app-timeline-item
                        v-for="(item, index) in alarmData['functiom']"
                        :key="index"
                        :time="item['create_date']"
                        :title="item['fault_name']"
                        :variant="
                        item['degree'] === '提醒'
                          ? 'info'
                          : item['degree'] === '一般'
                          ? 'warning'
                          : 'danger'
                      "
                        class="pb-1"
                    >
                    </app-timeline-item>
                  </app-timeline>
                  <p v-else class="text-center" style="margin-top: 20%">
                    暂无功能告警数据
                  </p>
                </vue-perfect-scrollbar>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {$themeColors} from "@themeConfig";
import {kFormatter} from "@/@core/utils/filter";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import useJwt from "@/libs/auth/jwt/useJwt";
import {Gauge, Area, Line, Column, DualAxes} from "@antv/g2plot";

export default {
  name: "Qingdao",
  components: {
    AppTimeline,
    AppTimelineItem,
    VuePerfectScrollbar,
  },
  data() {
    return {
      intervalFlag: null,
      projectBaseInfo: {},
      heatPrediction: {},
      heatPredictionMax: {
        'hour': {}, 'day': {}
      },
      realTimeParams: {},
      alarmData: {},
      operationalEvaluation: {},
      chart_1: null,
      chart_2: null,
      chart_3: null,
    };
  },
  watch: {},
  methods: {
    kFormatter,

    doGetPageData() {
      this.getProjectBaseInfo();
      this.getAlarmData();
      this.getEnergyData();
      this.getRealTimeData();
      // this.getOperationalEvaluation();
      this.getHeatPrediction();
    },
    getHeatPredictionMax(type = 'hour') {
      //找出this.heatPrediction中egname='预测值'，value最大的一条数据
      let maxData = null;
      for (let i = 0; i < this.heatPrediction[type].length; i++) {
        if (maxData == null) {
          maxData = this.heatPrediction[type][i];
        }
        if (this.heatPrediction[type][i].value > maxData.value) {
          maxData = this.heatPrediction[type][i];
        }
      }
      console.log(type, maxData)
      this.heatPredictionMax[type] = maxData
    },
    getHeatPrediction() {
      const axios = useJwt.axiosIns;
      axios.get("/api/qdnyz/params/heat-prediction", {project_id: 83}).then((res) => {
        console.log("heatPrediction", res.data);
        this.heatPrediction = res.data || {'hour': [], 'day': []};
        this.chart_1.changeData(res.data['hour'])
        this.chart_2.changeData(res.data['day'])
        this.getHeatPredictionMax('hour')
        this.getHeatPredictionMax('day')

      });
    },
    getProjectBaseInfo() {
      const axios = useJwt.axiosIns;
      axios.get("/api/qdnyz/params/project-base-info", {project_id: 83}).then((res) => {
        console.log("project_base_info", res.data);
        this.projectBaseInfo = res.data || {};
      });
    },
    getAlarmData() {
      const axios = useJwt.axiosIns;
      axios.get("/api/qdnyz/params/alarm", {project_id: 83}).then((res) => {
        console.log("alarm", res.data);
        this.alarmData = res.data;
      });
    },
    getEnergyData() {
      const axios = useJwt.axiosIns;
      axios.get("/api/qdnyz/params/energy", {project_id: 83}).then((res) => {
        const chart_1Data = res.data['_40742']
        const chart_2Data = res.data['_40025']
        // this.chart_1.changeData(chart_1Data)
        // this.chart_2.changeData(chart_2Data)
      });
    },
    getRealTimeData() {
      const axios = useJwt.axiosIns;
      axios
          .get("/api/qdnyz/params/real-time-params", {project_id: 83})
          .then((res) => {
            this.realTimeParams = res.data;
          });
    },
    getOperationalEvaluation() {
      const axios = useJwt.axiosIns;
      axios
          .get("/api/qdnyz/params/operational-evaluation", {project_id: 83})
          .then((res) => {
            this.operationalEvaluation = res.data;
          });
    },
    operationalEvaluationChartInit() {
      const gauge = new Gauge("container_3", {
        percent: 0.7222,
        type: "meter",
        innerRadius: 0.75,
        range: {
          ticks: [0, 1 / 3, 2 / 3, 1],
          color: ["#F4664A", "#FAAD14", "#30BF78"],
        },
        indicator: {
          pointer: {
            style: {
              stroke: "#D0D0D0",
            },
          },
          pin: {
            style: {
              stroke: "#D0D0D0",
            },
          },
        },
        statistic: {
          content: {
            style: {
              // fontSize: "36px",
              lineHeight: "40px",
              color: "#D0D0D0",
            },
          },
        },
      });
      gauge.render();
      this.chart_3 = gauge;
    },
    areaChart_1Init() {
      const areaChart_1 = new Area("container_1", {
        theme: {
          colors10: Object.values($themeColors),
        },
        legend: {
          itemName: {
            style: {fill: "#82868b"},
          },
          position: "top",
        },
        data: [],
        xField: "time",
        yField: "value",
        seriesField: "egname",
        isStack: false,
        xAxis: {
          label: {
            autoHide: true,
            autoRotate: false,
          },
          line: null,
          grid: null,
          tickLine: null,
        },
        yAxis: {
          nice: true,
          grid: {
            line: {
              style: {
                stroke: "#82868b",
                lineWidth: 1,
                lineDash: [1, 6],
                strokeOpacity: 0.7,
              },
            },
          },
        },
        animation: {
          appear: {
            animation: "wave-in",
            duration: 3000,
          },
        },
        smooth: true,
        style:{
          connect:false
        },
        meta: {
          value: {
            alias: "数值",
            formatter: (value) => {
              return Math.round(value * 100) / 100;
            },
          },
        },
      });

      areaChart_1.render();
      this.chart_1 = areaChart_1;
    },
    areaChart_2Init() {
      const areaChart_2 = new Area("container_2", {
        theme: {
          colors10: Object.values($themeColors),
        },
        legend: {
          itemName: {
            style: {fill: "#82868b"},
          },
          position: "top",
        },
        data: [],
        xField: "time",
        yField: "value",
        seriesField: "egname",
        isStack: false,
        xAxis: {
          label: {
            autoHide: true,
            autoRotate: false,
          },
          line: null,
          grid: null,
          tickLine: null,
        },
        yAxis: {
          nice: true,
          grid: {
            line: {
              style: {
                stroke: "#82868b",
                lineWidth: 1,
                lineDash: [1, 6],
                strokeOpacity: 0.7,
              },
            },
          },
        },
        animation: {
          appear: {
            animation: "wave-in",
            duration: 3000,
          },
        },
        smooth: true,
        style:{
          connect:false
        },
        meta: {
          value: {
            alias: "数值",
            formatter: (value) => {
              return Math.round(value * 100) / 100;
            },
          },
        },
      });

      areaChart_2.render();
      this.chart_2 = areaChart_2;
    },
    to_diagnosis() {
      this.$router.push("/83/cabr/diagnosis/agent-list");
    },
  },
  mounted() {
    this.areaChart_1Init()
    this.areaChart_2Init()
    // this.operationalEvaluationChartInit()
    // 获取数据
    this.doGetPageData();
    this.intervalFlag = setInterval(this.doGetPageData, 120 * 1000);
    // 初始化场景
    // this.initScene("babylonJsCanvas")
  },
  destroyed() {
    clearInterval(this.intervalFlag);
  },
};
</script>

<style lang="scss" scoped>
.adsk-viewing-viewer {
  background: none !important;
}

.homeViewWrapper {
  display: none !important;
}

.offsetMargin {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}
</style>
